
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3vsgC", function(module, exports) {
/* PageTreeSearchMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4yg9g = parcelRequire("4yg9g");


var $ad7Ou = parcelRequire("ad7Ou");


var $dTHYM = parcelRequire("dTHYM");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");


var $ep3mz = parcelRequire("ep3mz");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $2f73a6af0c975a3d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    searchButtonText: {
        id: "pagetree-search-macro.search-button-text",
        defaultMessage: "Search"
    },
    rootSpaceNotFound: {
        id: "pagetree-search-macro.root-space-not-found",
        defaultMessage: "The selected space cannot be found."
    },
    rootPageNotFound: {
        id: "pagetree-search-macro.root-page-not-found",
        defaultMessage: "The selected root page could not be found."
    },
    invalidPageContext: {
        id: "pagetree-search-macro.invalid-page-context",
        defaultMessage: "The selected context is not a valid hierarchical page"
    },
    error: {
        id: "pagetree-search-macro.error",
        defaultMessage: "We're unable to display the page tree search. Refresh to try again"
    }
});



var $fV8ei = parcelRequire("fV8ei");








var $kVsp1 = parcelRequire("kVsp1");


var $jMyy4 = parcelRequire("jMyy4");

const $6d9fa3f0c78af5b0$export$e419edb61f653ebd = (spaceKey, title, validateSpace, skip)=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $kVsp1.default), {
        variables: {
            spaceKey: spaceKey,
            title: title,
            validateSpace: validateSpace
        },
        skip: skip || !spaceKey || !title,
        __callerPackage__: "@confluence/pagetree-search-macro"
    });
    return {
        data: data,
        error: error,
        loading: loading
    };
};



var $34TzN = parcelRequire("34TzN");




const $a626a914245dd9d5$export$c920a664754b7d59 = (spaceKey, skip)=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $34TzN.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip || !spaceKey,
        __callerPackage__: "@confluence/pagetree-search-macro"
    });
    return {
        data: data,
        error: error,
        loading: loading
    };
};


const $8d51ce35d01124b6$export$7c95498158cdc673 = ({ rootPageString: rootPageString, defaultSpaceKey: defaultSpaceKey, contentId: contentId, contentType: contentType })=>{
    const parsed = (0, $cozmU.useMemo)(()=>rootPageString != null ? (0, $fV8ei.parseRootPageString)(rootPageString, defaultSpaceKey) : undefined, [
        rootPageString,
        defaultSpaceKey
    ]);
    const hasTitle = Boolean(parsed?.title);
    const hasExplicitSpace = parsed?.hasExplicitSpace ?? false;
    const shouldLookupPage = Boolean(parsed?.spaceKey) && hasTitle;
    // Space-only validation for "MYSPACE:" (explicit space, no title)
    const shouldValidateSpaceOnly = hasExplicitSpace && !hasTitle;
    // Combined query: resolves page, and validates space when explicitly provided
    const { data: data, error: error, loading: loading } = (0, $6d9fa3f0c78af5b0$export$e419edb61f653ebd)(parsed?.spaceKey ?? '', parsed?.title ?? '', hasExplicitSpace, !shouldLookupPage);
    // Space-only query: used when title is empty (e.g. "MYSPACE:")
    const { data: spaceData, error: spaceError, loading: spaceLoading } = (0, $a626a914245dd9d5$export$c920a664754b7d59)(parsed?.spaceKey ?? '', !shouldValidateSpaceOnly);
    return (0, $cozmU.useMemo)(()=>{
        // No rootPage parameter — fall back to the current page.
        // The legacy macro only allows this when the content is a Page (not blog, comment, etc.)
        if (parsed === undefined) {
            if (!contentId || contentType !== 'page') return {
                spaceKey: defaultSpaceKey,
                ancestorId: '',
                loading: false,
                errors: [
                    'invalidPageContext'
                ]
            };
            return {
                spaceKey: defaultSpaceKey,
                ancestorId: contentId,
                loading: false,
                errors: []
            };
        }
        // Wait for in-flight queries
        if (shouldLookupPage && loading || shouldValidateSpaceOnly && spaceLoading) return {
            spaceKey: parsed.spaceKey,
            ancestorId: '',
            loading: true,
            errors: []
        };
        // Collect errors independently, matching legacy behavior where both
        // space and page errors can appear simultaneously
        const errors = [];
        if (hasTitle) {
            // Combined query returned both space and content — check space from same response
            if (hasExplicitSpace && !data?.space) errors.push('rootSpaceNotFound');
            const resolvedId = data?.content?.nodes?.[0]?.id ?? null;
            if (error || !resolvedId) errors.push('rootPageNotFound');
            else return {
                spaceKey: parsed.spaceKey,
                ancestorId: resolvedId,
                loading: false,
                errors: errors
            };
        } else if (hasExplicitSpace) // Space-only validation (e.g. "MYSPACE:")
        {
            if (spaceError || !spaceData?.space) errors.push('rootSpaceNotFound');
        }
        return {
            spaceKey: parsed.spaceKey,
            ancestorId: '',
            loading: false,
            errors: errors
        };
    }, [
        parsed,
        hasTitle,
        hasExplicitSpace,
        shouldLookupPage,
        shouldValidateSpaceOnly,
        contentId,
        contentType,
        defaultSpaceKey,
        loading,
        error,
        data,
        spaceLoading,
        spaceError,
        spaceData
    ]);
};


const $03d2125f9b9a6644$var$styles = {
    searchInput: "_1bsb182l _2hwxu2gc"
};
const $03d2125f9b9a6644$var$ERROR_MESSAGES = {
    rootSpaceNotFound: (0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).rootSpaceNotFound,
    rootPageNotFound: (0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).rootPageNotFound,
    invalidPageContext: (0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).invalidPageContext
};
const $03d2125f9b9a6644$var$PageTreeSearchMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const [contentType] = (0, $ep3mz.useContentType)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { spaceKey: spaceKey, ancestorId: ancestorId, loading: loading, errors: errors } = (0, $8d51ce35d01124b6$export$7c95498158cdc673)({
        rootPageString: (0, $fV8ei.getRootPageParam)(macroParams),
        defaultSpaceKey: macroDefaultProps.spaceKey ?? '',
        contentId: macroDefaultProps.contentId,
        contentType: contentType
    });
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const handleSearchChange = (0, $cozmU.useCallback)((event)=>setSearchQuery(event.target.value), []);
    const handleSearchSubmit = (0, $cozmU.useCallback)(()=>{
        const trimmed = searchQuery.trim();
        if (!trimmed) return;
        const queryParams = {
            text: trimmed
        };
        if (spaceKey) queryParams.spaces = spaceKey;
        if (ancestorId) queryParams.ancestor = ancestorId;
        push((0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
            query: queryParams
        }));
    }, [
        push,
        searchQuery,
        spaceKey,
        ancestorId
    ]);
    const isEditorMode = macroDefaultProps.mode === 'editor';
    const hasErrors = errors.length > 0;
    const isSubmitDisabled = hasErrors || loading || isEditorMode;
    const trackingError = hasErrors ? new Error(errors.map((errorKey)=>{
        const msg = $03d2125f9b9a6644$var$ERROR_MESSAGES[errorKey];
        return msg ? formatMessage(msg) : errorKey;
    }).join(', ')) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: "pagetree-search-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, !loading && trackingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: trackingError
    }), !loading && !hasErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), hasErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: "pagetree-search-error"
    }, errors.map((errorKey)=>{
        const msg = $03d2125f9b9a6644$var$ERROR_MESSAGES[errorKey];
        return msg ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: errorKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), msg)) : null;
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSearchSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $03d2125f9b9a6644$var$styles.searchInput
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        value: searchQuery,
        onChange: handleSearchChange,
        name: "queryString",
        isDisabled: isEditorMode,
        testId: "pagetree-search-input",
        "aria-label": formatMessage((0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).searchButtonText)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        type: "submit",
        isDisabled: isSubmitDisabled,
        testId: "pagetree-search-button"
    }, formatMessage((0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).searchButtonText)))));
};
const $03d2125f9b9a6644$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2f73a6af0c975a3d$export$a7357cdd1f0b0168).error);
const $03d2125f9b9a6644$export$a5a313cfce6485fa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $03d2125f9b9a6644$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($03d2125f9b9a6644$var$PageTreeSearchMacroRendererComponent, props));
module.exports["PageTreeSearchMacroRenderer"] = $03d2125f9b9a6644$export$a5a313cfce6485fa;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("fV8ei", function(module, exports) {
/**
 * Extracts the raw `rootPage` macro parameter value, supporting all known
 * legacy parameter aliases (`rootPage`, `rootpage`, `'0'`).
 *
 * Returns `undefined` when no `rootPage` parameter is set.
 */ const $2efd9995ee26a8d7$export$7e7a804114e88dad = (macroParams)=>{
    if (!macroParams) return undefined;
    return macroParams.rootPage?.value ?? macroParams.rootpage?.value ?? macroParams['0']?.value;
};
const $2efd9995ee26a8d7$export$d0fe7d7e2f2da886 = (rootPageString, defaultSpaceKey)=>{
    const delimiterPos = rootPageString.indexOf(':');
    if (delimiterPos > -1) {
        const rawSpaceKey = rootPageString.substring(0, delimiterPos);
        const spaceKey = rawSpaceKey || defaultSpaceKey;
        const title = rootPageString.substring(delimiterPos + 1);
        return {
            spaceKey: spaceKey,
            title: title,
            hasExplicitSpace: Boolean(rawSpaceKey)
        };
    }
    return {
        spaceKey: defaultSpaceKey,
        title: rootPageString,
        hasExplicitSpace: false
    };
};
module.exports["getRootPageParam"] = $2efd9995ee26a8d7$export$7e7a804114e88dad;
module.exports["parseRootPageString"] = $2efd9995ee26a8d7$export$d0fe7d7e2f2da886;

});

parcelRegister("kVsp1", function(module, exports) {
/**
 * @generated SignedSource<<ac24f7a863948accfbd6d59cbbee7264>>
 * @relayHash 4484fadd23c040a81eec65da02ab0cd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4
const $87e1172a98f7d3d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "validateSpace"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v2 = [
        {
            "condition": "validateSpace",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "4484fadd23c040a81eec65da02ab0cd9",
            "id": "8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4",
            "metadata": {},
            "name": "usePageTreeSearchQueryQuery",
            "operationKind": "query",
            "text": "query usePageTreeSearchQueryQuery($spaceKey:String!,$title:String!,$validateSpace:Boolean!){space(key:$spaceKey)@include(if:$validateSpace){id},content(spaceKey:$spaceKey,title:$title,type:\"page\"){nodes{id}}}"
        }
    };
}();
$87e1172a98f7d3d7$var$node.hash = "1be6e27ce1b78f4f22a3ff6689bbf9e4";
var $87e1172a98f7d3d7$export$2e2bcd8739ae039 = $87e1172a98f7d3d7$var$node;
module.exports["default"] = $87e1172a98f7d3d7$export$2e2bcd8739ae039;

});

parcelRegister("34TzN", function(module, exports) {
/**
 * @generated SignedSource<<71bcfe57e49ffa98a90c029ce20a0c42>>
 * @relayHash a2a71f8c82ac5eef37dab68dd9909961
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc
const $3a566bea7c41a78b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2a71f8c82ac5eef37dab68dd9909961",
            "id": "1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc",
            "metadata": {},
            "name": "useSpaceValidationQueryQuery",
            "operationKind": "query",
            "text": "query useSpaceValidationQueryQuery($spaceKey:String!){space(key:$spaceKey){id}}"
        }
    };
}();
$3a566bea7c41a78b$var$node.hash = "7638ca6f03f75527639ed0545762f27e";
var $3a566bea7c41a78b$export$2e2bcd8739ae039 = $3a566bea7c41a78b$var$node;
module.exports["default"] = $3a566bea7c41a78b$export$2e2bcd8739ae039;

});


//# sourceMappingURL=PageTreeSearchMacroRenderer.8831de56.js.map
